import React from "react";
import Loading from "../../Others/Loading";
// import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// function strfDate(date) {
//   let dates = new Date(date).toDateString().slice(4, 10);
//   let time = new Date(date).toLocaleTimeString(navigator.language, {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   });
//   return dates + ", " + time;
// }

function strfDate(date) {
  let dates = new Date(date);
  if (dates.getFullYear() === new Date().getFullYear()) {
    return dates.toDateString().slice(4, 10);
  } else {
    let year = new Date(date).toDateString().slice(10, 15);
    return dates + ", " + year;
  }
}

function OrderCard({ order }) {
  const navigate = useNavigate();

  // const status = {
  //   Accepted: "bg-success text-white round-2 px-2 py-1 fw-bolder",
  //   Pending: "bg-orange text-white round-2  px-2 py-1 fw-bolder",
  //   Cancelled: "bg-danger text-white round-2 px-2 py-1 fw-bolder",
  //   Delivered: "bg-primary text-white round-2 px-2 py-1 fw-bolder",
  // };
  // const strip = {
  //   Accepted: "bg-snap",
  //   Pending: "bg-yello",
  //   Cancelled: "bg-snap-red",
  //   Delivered: "bg-snap-orange",
  // };
  return (
    <>
      {order ? (
        <div className="col">
          <div
            className="border-bottom py-2 mt-0"
            onClick={() => navigate(`/orderstatus/${order.order_id}`)}
          >
            <div className="d-flex" style={{ height: "45px" }}>
              <div className="d-flex my-auto">
                {order?.status === "Pending" ? (
                  <div>
                    <div className={"d-flex round-2 bg-yellow pe-1 py-1"}>
                      <div className="d-flex flex-column my-auto">
                        <div className="lh-1">
                          <span
                            className="fw-bolder text-brown ms-1"
                            style={{ fontSize: "18px" }}
                          >
                            Pending
                          </span>
                        </div>
                      </div>
                      <div
                        className="rounded-circle d-flex my-auto bg-light p-1"
                        style={{
                          marginLeft: "7px",
                        }}
                      >
                        <i
                          className="bi bi-clock-history text-brown my-auto fs-2"
                          style={{ lineHeight: "0.8" }}
                        ></i>
                      </div>
                    </div>
                  </div>
                ) : order?.status === "Accepted" ? (
                  <div>
                    <div className={"d-flex round-2 bg-snap pe-1 py-1"}>
                      <div className="d-flex flex-column my-auto">
                        <div className="lh-1">
                          <span
                            className="fw-bolder text-green ms-1"
                            style={{ fontSize: "18px" }}
                          >
                            Accepted
                          </span>
                        </div>
                      </div>
                      <div
                        className="rounded-circle d-flex my-auto bg-light"
                        style={{
                          marginLeft: "7px",
                        }}
                      >
                        <i className="bi bi-handbag-fill text-green my-auto lh-1 fs-4 p-1"></i>
                      </div>
                    </div>
                  </div>
                ) : order?.status === "Delivered" ? (
                  <div>
                    <div className={"d-flex round-2 bg-light-orange pe-1 py-1"}>
                      <div className="d-flex flex-column my-auto">
                        <div className="lh-1">
                          <span
                            className="fw-bolder text-orange ms-1"
                            style={{ fontSize: "18px" }}
                          >
                            Delivered
                          </span>
                        </div>
                      </div>
                      <div
                        className="rounded-circle d-flex my-auto bg-light"
                        style={{
                          marginLeft: "7px",
                        }}
                      >
                        <i className="bi bi-check-lg text-orange my-auto lh-1 fs-2"></i>
                      </div>
                    </div>
                  </div>
                ) : order?.status === "Cancelled" ? (
                  <div>
                    <div className={"d-flex round-2 bg-snap-red pe-1 py-1"}>
                      <div className="d-flex flex-column my-auto">
                        <div className="lh-1">
                          <span
                            className="fw-bolder text-danger ms-1"
                            style={{ fontSize: "18px" }}
                          >
                            Cancelled
                          </span>
                        </div>
                      </div>
                      <div
                        className="rounded-circle d-flex my-auto bg-light p-1"
                        style={{
                          marginLeft: "7px",
                        }}
                      >
                        <i className="bi bi-x-lg text-danger my-auto lh-1"></i>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="my-auto d-flex w-100">
                <div className="ms-auto d-flex flex-column pe-3">
                  <span className="my-auto ms-3">
                    <b className="" style={{ fontSize: "15px" }}>
                      Order: #{order.vendor_order_no}
                    </b>
                  </span>
                  <span
                    className="ms-3 fw-bold text-muted text-end"
                    style={{ fontSize: "11px" }}
                  >
                    Placed On: {strfDate(order.orderplaced)}
                  </span>
                </div>
              </div>
            </div>
            {/* border-start border-width */}
            <div className="card-body d-flex p-2 pb-2 ">
              <div className="d-flex lh-sm flex-column w-50">
                <div
                  className="fw-bolder pe-3"
                  style={{
                    fontSize: "14px",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                >
                  {order?.shopname}
                </div>
                <div className="d-flex flex-column">
                  <span
                    className="fw-bolder text-muted"
                    style={{
                      fontSize: "13px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                    }}
                  >
                    {order?.vendoraddress}
                  </span>
                  <span
                    className="fw-bolder text-muted"
                    style={{ fontSize: "12px" }}
                  >
                    {order?.vendorcity}
                  </span>
                </div>
              </div>

              <div className="w-50 d-flex">
                <div className="my-auto bg-light-orange rounded-3 text-orange fw-bolder px-2 py-1">
                  COD
                </div>
                <div className="d-flex w-75 ms-auto my-auto">
                  <div className="ms-auto">
                    <span
                      className="fs-6 text-muted"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {order.order_count} Item{order.order_count > 1 && "s"}
                    </span>
                    <div className="fs-6 lh-1">
                      ₹{order.billamount?.toLocaleString("en-IN")}
                    </div>
                  </div>
                  <i className="bi bi-chevron-right my-auto text-muted ps-1 fw-bolder pt-1"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
}

export default OrderCard;
